import { Directive, OnDestroy, OnInit, inject } from '@angular/core';
import { routeOverride } from '@df/core/meta/route-override.pipe';
import { AbService } from '@df/module-ab/ab.service';
import { NgInject } from '@df/ng/ng-inject';
import { Basket } from '@df/session/api/basket/basket';
import { BasketItem } from '@df/session/api/basket/basket-item';
import { BasketService } from '@df/session/api/basket/basket.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { ToggleBlockAbstact } from '../../common/toggle-block.abstract';

export const MINIBASKET_FORBIDDEN_LOCATIONS = ['/basket', '/checkout', '/success'];

@Directive()
export abstract class MinibasketComponentDef extends ToggleBlockAbstact implements OnInit, OnDestroy {
    get basket(): Basket {
        return this.app.customer.basket;
    }

    basketSubscription?: Subscription;
    basketSuccessSubscription?: Subscription;

    isInStock = false;
    isSalable = false;

    protected name = 'minibasket';

    protected override forbiddenLocations = MINIBASKET_FORBIDDEN_LOCATIONS.map(i => routeOverride(i));

    basketService = inject(BasketService);
    readonly abService = inject(AbService);

    override ngOnInit() {
        this.subscribeToBasketChange();
        this.subscribeToBasketAdd();
        this.onBasketUpdate();
        super.ngOnInit();
    }

    protected subscribeToBasketChange() {
        this.basketSubscription = this.basket.subscribe(() => this.onBasketUpdate());
    }

    protected subscribeToBasketAdd() {
        this.basketSuccessSubscription = this.basketService.subscribeToAddToBasketSuccess(() => {
            super.show();
            // this.detectChanges();
        });
    }

    onBasketUpdate() {
        this.isSalable = this.basket.isSalable;
        this.isInStock = this.basket.isInStock;
        this.detectChanges();
    }

    override ngOnDestroy() {
        if (this.basketSubscription) {
            this.basketSubscription.unsubscribe();
        }

        if (this.basketSuccessSubscription) {
            this.basketSuccessSubscription.unsubscribe();
        }
        super.ngOnDestroy();
    }

    protected runExperiment(name: string): void {
        if (this.app.isPlatformBrowser && window['convert']?.data?.experiments) {
            const experiment = this.abService.getExpById(name);

            if (experiment?.key) {
                window[`runExperiment${experiment.key}`] = 1;

                window['_conv_q'] = window['_conv_q'] || [];
                window['_conv_q'].push(['executeExperiment', `${experiment.key}`]);
                this.app.logger.log('executeExperiment', experiment.key);
            }
        }
    }

    trackByItemId = (index: number, item: BasketItem) => item.id;
}
